if (document.querySelector('[data-filter-responsive="opener"]')) document.querySelector('[data-filter-responsive="opener"]').addEventListener("click", dropdownFilterShow);

function dropdownFilterShow() {
	// $(".filter__responsive").show();
}
